import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./style.css";
// import $ from "jquery";

// import "./navPlugin";

export default class Navbar extends Component {
  state = {
    items: [],
  };

  static getDerivedStateFromProps(nextProps, prevProps) {
    if (nextProps.items !== prevProps.items) {
      return {
        items: nextProps.items,
      };
    }
  }

  render() {
    const { items } = this.state;
    const { trans } = this.props;
    let transClassess = trans
      ? "navbar navbar-expand-lg navbar-dark fixed-top transBG"
      : "navbar navbar-expand-lg navbar-dark fixed-top";
    return (
      <nav
        className={transClassess}
        id="mainNav"
        // className="transBG"
      >
        <div className="container">
          <Link
            to="/"
            className="navbar-brand js-scroll-trigger"
            href="#page-top"
          >
            Mohamed Khaled
          </Link>
          <button
            className="navbar-toggler navbar-toggler-right"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            Menu
            <i className="fas fa-bars"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav text-uppercase ml-auto">
              {items &&
                items.map((i, index) => (
                  <li key={"item-"+index} className="nav-item" key={index}>
                    <a
                      className="nav-link js-scroll-trigger"
                      href={`#${i.target}`}
                    >
                      {i.name}
                    </a>
                  </li>
                ))}
              {/* <li className="nav-item">
                                <a className="nav-link js-scroll-trigger" href="#portfolio">Portfolio</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link js-scroll-trigger" href="#about">About</a>
                            </li>
                          */}
              {/* services */}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
